module.exports = __webpack_public_path__ + "static/media/covi_ppe_fac_mas.308f4410.png";